import React from "react"

const FontAwesome = props => <i className={props.className} onClick={props.onClick} />;

export default FontAwesome